import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { SEARCH_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useSearchCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useSearchCarInPrepare() {
  const { startListen } = useWebSocketStore()
  const { updateSearchCar } = useUpdateCar()

  const carInPrepare = () => {
    startListen({
      eventName: 'premium.CAR_IN_PREPARE',
      callbackName: SEARCH_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId } = event.context

        updateSearchCar(carId, (data) => {
          return {
            ...data,
            stage: 'IN_PREPARATION',
          }
        })
      },
    })
  }

  return { carInPrepare }
}
